import { render, staticRenderFns } from "./Header1.vue?vue&type=template&id=58234d57&scoped=true&"
import script from "./Header1.vue?vue&type=script&lang=js&"
export * from "./Header1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58234d57",
  null
  
)

export default component.exports